import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const nav = useNavigate();
    const { hydrateFromToken } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const params = new URLSearchParams(location.hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            nav("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await client.post("/auth/google/session", {}, {
                    headers: { "X-Session-ID": sessionId },
                    withCredentials: true,
                });
                await hydrateFromToken(data.token, data.user);
                toast.success(`Signed in as ${data.user.email}`);
                nav("/app", { replace: true });
            } catch (err) {
                toast.error(err?.response?.data?.detail || "Google sign-in failed");
                nav("/login", { replace: true });
            }
        })();
    }, [location.hash, nav, hydrateFromToken]);

    return (
        <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback-loading">
            <div className="text-muted-foreground font-mono text-sm">completing sign-in…</div>
        </div>
    );
}
